/**
 * Should clear left after animation.
 *
 * Returns whether inline `left` should be cleared after animation cleanup.
 * Only slideTop and slideBottom set inline `left` in animateElement.
 * Other styles must not clear `left` set by positioning such as dropdown alignment.
 *
 * @since ??
 *
 * @param {JQuery} $element The element being cleaned up.
 *
 * @returns {boolean} True when inline `left` should be reset.
 */
export const shouldClearLeftAfterAnimation = ($element: JQuery): boolean =>
  $element.hasClass('slideTop') || $element.hasClass('slideBottom');
